module.exports = __webpack_public_path__ + "static/media/cmcc-v1-connect.5e000002.png";